import { PAYU_CALLBACK_URL, PAYU_KEY, PAYU_URL } from "../../constants/config";
import { foramtNumberToTwoDecimalPlaces } from "../../utils/commonUtils";

export function PayUPaymentHandler(providerDetails, amount) {
  const params = {
    key: PAYU_KEY,
    txnid: providerDetails.gateway_order_id,
    amount: foramtNumberToTwoDecimalPlaces(amount),
    productinfo: providerDetails.product_info,
    firstname: providerDetails.first_name,
    email: providerDetails.email,
    phone: providerDetails.phone,
    surl: PAYU_CALLBACK_URL,
    furl: PAYU_CALLBACK_URL,
    hash: providerDetails.hash,
  };
  const form = document.createElement("form");
  form.method = "POST";
  form.action = PAYU_URL;

  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined && value !== "") {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }
  }

  document.body.appendChild(form);

  form.submit();
}
